let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hTf6Q")).then(() => parcelRequire('1EinG'));